import React from "react";
import { injectIntl } from "react-intl";
import { localize } from "cci-utility";
import SelectField from "./SelectField";

/**
 * A variation of the SelectField component that receives an array of react-intl messages and whose value is a simple string.
 *
 * Props:
 * - options: Array of react-intl messages, which will be localized before being passed on to react-select. The id of the message corresponds to the value in react-select.
 * - value: Value string as found in the message.id property.
 */
const SelectValueField = ({
  intl,
  options,
  value,
  onChange,
  defaultValue,
  ...restProps
}) => {
  const optionsObjectArray = options.map(option => ({
      value: option.id,
      label: localize(intl, option)
    })),
    selectedOption = optionsObjectArray.find(
      option =>
        option.value === defaultValue + "" || option.value === value + ""
    );

  return (
    <SelectField
      {...restProps}
      onChange={selected => {
        onChange(selected && selected.value, selected);
      }}
      options={optionsObjectArray}
      value={selectedOption || null}
    />
  );
};

export default injectIntl(SelectValueField);
